export default class CustomerMetadata {
	idvSeen: boolean = false;

	constructor(init: Partial<CustomerMetadata>) {
		this.idvSeen = init?.idvSeen || init?.idvSeen || this.idvSeen;
	}
}
